var _excluded = ["size"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
var SingleGraphicIcon = function SingleGraphicIcon(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 48 : _props$size,
    otherProps = _objectWithoutProperties(props, _excluded);
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "SINGLE-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0a3.567 3.567 0 100 7.134A3.567 3.567 0 0012 0zm0 1a2.567 2.567 0 110 5.134A2.567 2.567 0 0112 1zM12 7.667a5.1 5.1 0 00-5.1 5.1v3.066l.008.09a.5.5 0 00.492.41h1.08l.723 7.216A.5.5 0 009.7 24h4.6l.084-.007a.5.5 0 00.413-.443l.722-7.216h1.08a.5.5 0 00.5-.5v-3.066A5.1 5.1 0 0012 7.667zm.205 1.005a4.1 4.1 0 013.895 4.095l-.001 2.566h-1.032l-.084.007a.5.5 0 00-.414.443L13.847 23h-3.695l-.721-7.216-.015-.082a.5.5 0 00-.483-.368H7.9v-2.566a4.1 4.1 0 014.1-4.1l.205.005z"
  })));
};
SingleGraphicIcon.displayName = "SingleGraphicIcon";
SingleGraphicIcon.displayName = "SingleGraphicIcon";
SingleGraphicIcon.iconName = "Single";
export default SingleGraphicIcon;